var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5341 7.59865L9.36987 3.96012C9.17024 3.78569 9.14981 3.48246 9.32423 3.28283C9.49866 3.0832 9.80189 3.06277 10.0015 3.2372L15.1215 7.71082C15.1228 7.71197 15.1241 7.71312 15.1254 7.71428C15.228 7.80231 15.293 7.9329 15.293 8.07865C15.293 8.25719 15.1955 8.41295 15.0509 8.49565L10.002 12.9197C9.80265 13.0944 9.49939 13.0744 9.32468 12.875C9.14997 12.6756 9.16998 12.3724 9.36936 12.1976L13.5223 8.55865L2.17555 8.55865C1.91045 8.55865 1.69555 8.34375 1.69555 8.07865C1.69555 7.81356 1.91045 7.59865 2.17555 7.59865L13.5341 7.59865Z",
    fill: "#F6F5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.dcf21bdc02f63da54f5463b72925c901.svg";
export { ForwardRef as ReactComponent };